import { cn } from '@/lib/utils'

/**
 * A hairline that fades out at both ends, dimmer in the dark theme.
 *
 * It lies flat unless told otherwise: a caller that stands it upright sets its
 * size and turns the fade with `[--to:to_bottom]`.
 */
export function Divider({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'block h-px shrink-0 bg-[linear-gradient(var(--to),transparent,hsl(var(--border)/var(--line)),transparent)] [--line:1] [--to:to_right] dark:[--line:0.4]',
        className
      )}
    />
  )
}
